import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from 'src/ui/layout';
import { updateBodyClass } from 'src/helpers';
import { SERVICEINIT_URL, SERVICEINIT_URL_ADDSI, BODY_CLASSES } from 'src/constants/constants.js';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';
import withRouter from 'src/utils/withRouter';

//Lazy Load
const ServiceInitAddContainer = lazy(() => import('src/ui/features/ServiceInit/containers/ServiceInitAddContainer'));
const ServiceInitLandingContainer = lazy(() => import('src/ui/features/ServiceInit/containers/ServiceInitLandingContainer'));
const ServiceInitAddContainerWithRouter = withRouter(ServiceInitAddContainer);
const ServiceInitLandingContainerWithRouter = withRouter(ServiceInitLandingContainer);

class ServiceInitRoot extends React.Component {
  componentDidMount() {
    updateBodyClass(BODY_CLASSES.SERVICEINIT);
  }

  componentWillUnmount() {
    updateBodyClass(BODY_CLASSES.SERVICEINIT);
  }

  render() {
    return (
      <Layout headerName={'Service Initiation'}>
        <Suspense fallback={<ServiceSpinner open={true} />}>
          <Routes>
            <Route
              path={'add/:assigneeServicePlanGlobalId'}
              element={<ServiceInitAddContainerWithRouter />}
            />
            <Route path={'add'} element={<ServiceInitAddContainerWithRouter />} />
            <Route path={'*'} element={<ServiceInitLandingContainerWithRouter />} />
          </Routes>
        </Suspense>
      </Layout>
    );
  }
}

export default ServiceInitRoot;
